export default __webpack_public_path__ + "static/Graphik-Semibold-Cy-Web-dcc4a1f680749717a7e2b594fb61ed10.woff2";